/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Set_RemovedInputs */

const en_us2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set removed, today only`)
};

const pt_br2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série retirada, só hoje`)
};

const es_419_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie quitada, solo hoy`)
};

const pt_pt2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série retirada, só hoje`)
};

const fr_fr2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série retirée, aujourd'hui seulement`)
};

const de_de2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz entfernt, nur heute`)
};

const it_it2_workout_set_removed = /** @type {(inputs: Workout_Set_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie tolta, solo oggi`)
};

/**
* | output |
* | --- |
* | "Set removed, today only" |
*
* @param {Workout_Set_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_removed = /** @type {((inputs?: Workout_Set_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_removed(inputs)
	if (locale === "es-419") return es_419_workout_set_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_removed(inputs)
	if (locale === "de-DE") return de_de2_workout_set_removed(inputs)
	if (locale === "it-IT") return it_it2_workout_set_removed(inputs)
	return en_us2_workout_set_removed(inputs)
});
export { workout_set_removed as "workout.set_removed" }